<template>
    <LayoutPage
        imageName="map-bg.jpg"
        :title="title">
         <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="title"
                :description="description"
            />
        </template>

        <template v-slot:content>
            <div class="box box--space-vertical">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">
                            <div v-if="workflowRequestState === 'success'">
                                <PostPreview
                                    v-for="item in workflows"
                                    :key="item.id"
                                    :id="item.seo_id"
                                    :title="item.title"
                                    :attachments="item.attachments"
                                    maskClassName='mm-mask--right'
                                    :to="localeRoute({name: 'workshops_id', params: { id: item.seo_id}})">
                                    <template v-slot:content>
                                        <div class="box box--space-top">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col col-md-auto">
                                                            <div class="box">
                                                                <div class="text--smaller-paragraph">
                                                                    Dátum:
                                                                </div>
                                                                <div class="headline headline--fifth">
                                                                    {{item.data.date}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col col-md-auto">
                                                            <div class="box">
                                                                <div class="text--smaller-paragraph">
                                                                    Miesto:
                                                                </div>
                                                                <div class="headline headline--fifth">
                                                                    {{item.data.place}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col col-md-auto">
                                                            <div class="">
                                                                <div class="text--smaller-paragraph">
                                                                    Cena:
                                                                </div>
                                                                <div class="headline headline--fifth">
                                                                    {{item.data.price}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col box box--space-top-s">
                                                            <strong>
                                                                Komu je workshop určený: {{item.data.targetAudience}}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </PostPreview>
                                <slot name="content"></slot>
                            </div>
                            <div v-else-if="workflowRequestState === 'request'">
                                <app-spinner />
                            </div>
                            <div v-else>
                                <p class="text text--error">
                                    Doslo k chybe. Zkontrolujte prosim formular a odeslete ho znovu
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import webCMS from '@/services/WebCMS';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import PostPreview from '@/components/PostPreview';

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        PostPreview
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        limit: {
            type: Number,
            default: 500
        }
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData(this.limit, 0);
    },
    data() {
        return {
            workflows: null,
            workflowRequestState: null
        }
    },
    methods: {
        loadData(limit, offset) {
            this.workflowRequestState = "request";
            webCMS.getWorkshops(this.axios, {limit, offset})
                .then(res => {
                    this.workflowRequestState = "success";
                    this.workflows = res;
                })
                .catch(error => {
                    this.workflowRequestState = "failure";
                    console.log(error);
                });
        }
    }
}
</script>
